import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { IonButton, IonIcon, ModalController } from '@ionic/angular/standalone';
import { ConnectivityService } from '@okcargo-apps/shared-infrastructure';
import { UploadFreightFileModalComponent } from '../upload-freight-file-modal/upload-freight-file-modal.component';

@Component({
  selector: 'lib-upload-freight-file-button',
  templateUrl: './upload-freight-file-button.component.html',
  styleUrls: ['./upload-freight-file-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IonIcon, IonButton],
})
export class UploadFreightFileButtonComponent {
  private readonly modalCtrl = inject(ModalController);
  private readonly connectivity = inject(ConnectivityService);

  /** Uploading a freight file is a command: it cannot be done without connection. */
  protected readonly isOffline = this.connectivity.isOffline;

  async showUploadFreightFileModal(): Promise<void> {
    if (this.isOffline()) return;

    const modal = await this.modalCtrl.create({
      component: UploadFreightFileModalComponent,
      componentProps: {},
      backdropDismiss: false,
    });
    modal.present();
  }
}
